import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, ButtonProps as MuiButtonProps } from '@mui/material'
import React, { memo } from 'react'

export interface DailogPopupProps {
  open: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
  title?: string;
  loading?: boolean;
  children?: React.ReactElement | React.ReactElement[];
  cancelTitle?: string;
  confirmTitle?: string;
  isDivider?: boolean;
  isColumn?: boolean;
  cancelButtonProps?: MuiButtonProps;
  confirmButtonProps?: MuiButtonProps; 
  disableSubmit?: boolean;
   resendButton?: React.ReactElement | null;
   submitText?: string;
    hideCancelButton?: boolean;
}

const DailogPopup: React.FC<DailogPopupProps> = memo((props:DailogPopupProps) => {
  const { isDivider = true } = props;
  return (
    <Dialog open={props.open} maxWidth={'md'}>
    {props.title && <><DialogTitle>{props.title}</DialogTitle>
    <Divider/></>}
    <DialogContent>
       {props.children}
    </DialogContent>
    {isDivider && <Divider/>}
<DialogActions
  style={{
    padding: 16,
    flexDirection: props.isColumn ? 'column' : 'row',
    gap: 8,
    justifyContent: 'center',
    alignItems: 'center',
  }}
>
  {/* ✅ Show Cancel button only if not explicitly hidden */}
  {!props.hideCancelButton && (
    <Button
      disabled={props.loading}
      variant="outlined"
      onClick={props.onCancel}
      color="primary"
      {...props.cancelButtonProps}
    >
      {props.cancelTitle ?? 'Cancel'}
    </Button>
  )}

  {/* ✅ Use custom submitText if provided */}
  <Button
    disabled={props.loading || props.disableSubmit}
    variant="contained"
    onClick={props.onSubmit}
    color="primary"
    {...props.confirmButtonProps}
  >
    {props.submitText || props.confirmTitle || 'Submit'}
  </Button>

  {/* Resend button (optional) */}
  {props.resendButton && (
    <div style={{ marginTop: props.isColumn ? 8 : 0 }}>
      {props.resendButton}
    </div>
  )}
</DialogActions>

</Dialog>
  )
});

export default DailogPopup;